module.exports = __webpack_public_path__ + "static/media/im-savings@2x.0812307f.svg";